import "../component_style/skill.css"
import js from "../image/js.svg"
import css from "../image/css.svg"
import html from "../image/html.svg"
import react from "../image/react.svg"
import nodejs from "../image/nodejs.png"
import redux from "../image/redux.svg"
import mongodb from "../image/mongo.webp"
import Bootstarap from "../image/bootstarp.svg"

export default function Skill (){
    return(
        <div>
            
            <h1 className="skill_Head"><b>Tools I Use</b></h1>
        <div className="about_skill">
        <div>
            <img src={html}/>
            <p>HTML</p>
        </div>

        <div>
            <img src={css} />
            <p>CSS</p>
        </div>

        <div>
            <img src={js} />
            <p>JavaScript</p>
        </div>

        <div>
            <img src={react}/>
            <p>React</p>
        </div>

        <div>
            <img src={nodejs}/>
            <p>Node</p>
        </div>

        <div>
            <img src={redux}/>
            <p>Redux</p>
        </div>


        <div>
            <img src={mongodb} />
            <p>Mongodb</p>
        </div>

        <div>
            <img src={Bootstarap}/>
            <p>Bootstrap</p>
        </div>



        </div>
        </div>

    )
}